  <div *ngFor="let data of filtersSections | keyvalue: originalOrder" translate-namespace="filter">
    <section id={{data.key}} class="Flexbox Flexbox__box-direction-column Marginbox__b-tiny filter-section">
           <dls-expander class="filter-group fs6_5" [header]="data.key|translate" [expanded]="'true'">
            <div *ngFor="let filter of data.value.filters" class="filter">
                <span class="filter-name" id="filterLabelName">{{filter.translatedName}}</span>
                <div id={{filter.name}} class="Flexbox filter-input">
                  <gen-filter-input [filter]="filter" class="Flexbox Flexbox__flex-1"></gen-filter-input>
                </div>
            </div>
        </dls-expander>   
    </section>
  </div> 